/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  Course,
  CourseBookmarkInput,
  CourseDetail,
  ListCoursesParams,
  PaginatedCourses,
  SchemaValidationErrorResponse,
  SearchCoursesParams
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * @summary Create Bookmark
 */
export const createCourseBookmark = (
    courseBookmarkInput: MaybeRefOrGetter<CourseBookmarkInput>,
 signal?: AbortSignal
) => {
      courseBookmarkInput = toValue(courseBookmarkInput);

      return axiosClient<Course>(
      {url: `/course_bookmark`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: courseBookmarkInput, signal
    },
      );
    }




export const getCreateCourseBookmarkMutationKey = () => ['createCourseBookmark'] as const;

export const getCreateCourseBookmarkMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCourseBookmark>>, TError,CreateCourseBookmarkMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createCourseBookmark>>, TError,CreateCourseBookmarkMutationVariables, TContext> => {

const mutationKey = getCreateCourseBookmarkMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCourseBookmark>>, CreateCourseBookmarkMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createCourseBookmark(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateCourseBookmarkMutationResult = NonNullable<Awaited<ReturnType<typeof createCourseBookmark>>>
    export type CreateCourseBookmarkMutationBody = CourseBookmarkInput
    export type CreateCourseBookmarkMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type CreateCourseBookmarkMutationVariables = {data: CourseBookmarkInput}

    /**
 * @summary Create Bookmark
 */
export const useCreateCourseBookmark = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCourseBookmark>>, TError,CreateCourseBookmarkMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createCourseBookmark>>,
        TError,
        CreateCourseBookmarkMutationVariables,
        TContext
      > => {
      return useMutation(getCreateCourseBookmarkMutationOptions(options), queryClient);
    }
    /**
 * @summary Delete Bookmark
 */
export const deleteCourseBookmark = (
    courseBookmarkInput: MaybeRefOrGetter<CourseBookmarkInput>,
 signal?: AbortSignal
) => {
      courseBookmarkInput = toValue(courseBookmarkInput);

      return axiosClient<Course>(
      {url: `/course_bookmark`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: courseBookmarkInput, signal
    },
      );
    }




export const getDeleteCourseBookmarkMutationKey = () => ['deleteCourseBookmark'] as const;

export const getDeleteCourseBookmarkMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCourseBookmark>>, TError,DeleteCourseBookmarkMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteCourseBookmark>>, TError,DeleteCourseBookmarkMutationVariables, TContext> => {

const mutationKey = getDeleteCourseBookmarkMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCourseBookmark>>, DeleteCourseBookmarkMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  deleteCourseBookmark(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteCourseBookmarkMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCourseBookmark>>>
    export type DeleteCourseBookmarkMutationBody = CourseBookmarkInput
    export type DeleteCourseBookmarkMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type DeleteCourseBookmarkMutationVariables = {data: CourseBookmarkInput}

    /**
 * @summary Delete Bookmark
 */
export const useDeleteCourseBookmark = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCourseBookmark>>, TError,DeleteCourseBookmarkMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteCourseBookmark>>,
        TError,
        DeleteCourseBookmarkMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteCourseBookmarkMutationOptions(options), queryClient);
    }
    /**
 * @summary List of Courses
 */
export const listCourses = (
    params?: MaybeRefOrGetter<ListCoursesParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<PaginatedCourses>(
      {url: `/courses`, method: 'GET',
        params, signal
    },
      );
    }




export const getListCoursesQueryKey = (params?: MaybeRefOrGetter<ListCoursesParams>,) => {
    return [
    'courses', ...(params ? [params] : [])
    ] as const;
    }


export const getListCoursesQueryOptions = <TData = Awaited<ReturnType<typeof listCourses>>, TError = ErrorType<SchemaValidationErrorResponse>>(params?: MaybeRefOrGetter<ListCoursesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCourses>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListCoursesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCourses>>> = ({ signal }) => listCourses(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCourses>>, TError, TData>
}

export type ListCoursesQueryResult = NonNullable<Awaited<ReturnType<typeof listCourses>>>
export type ListCoursesQueryError = ErrorType<SchemaValidationErrorResponse>


/**
 * @summary List of Courses
 */

export function useListCourses<TData = Awaited<ReturnType<typeof listCourses>>, TError = ErrorType<SchemaValidationErrorResponse>>(
 params?: MaybeRefOrGetter<ListCoursesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCourses>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListCoursesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Search Courses
 */
export const searchCourses = (
    params?: MaybeRefOrGetter<SearchCoursesParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<PaginatedCourses>(
      {url: `/courses/search`, method: 'GET',
        params, signal
    },
      );
    }




export const getSearchCoursesQueryKey = (params?: MaybeRefOrGetter<SearchCoursesParams>,) => {
    return [
    'courses','search', ...(params ? [params] : [])
    ] as const;
    }


export const getSearchCoursesQueryOptions = <TData = Awaited<ReturnType<typeof searchCourses>>, TError = ErrorType<SchemaValidationErrorResponse>>(params?: MaybeRefOrGetter<SearchCoursesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchCourses>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getSearchCoursesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchCourses>>> = ({ signal }) => searchCourses(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof searchCourses>>, TError, TData>
}

export type SearchCoursesQueryResult = NonNullable<Awaited<ReturnType<typeof searchCourses>>>
export type SearchCoursesQueryError = ErrorType<SchemaValidationErrorResponse>


/**
 * @summary Search Courses
 */

export function useSearchCourses<TData = Awaited<ReturnType<typeof searchCourses>>, TError = ErrorType<SchemaValidationErrorResponse>>(
 params?: MaybeRefOrGetter<SearchCoursesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchCourses>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSearchCoursesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Get Course
 */
export const getCourse = (
    id: MaybeRefOrGetter<number>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<CourseDetail>(
      {url: `/courses/${id}`, method: 'GET', signal
    },
      );
    }




export const getGetCourseQueryKey = (id: MaybeRefOrGetter<number>,) => {
    return [
    'courses',id
    ] as const;
    }


export const getGetCourseQueryOptions = <TData = Awaited<ReturnType<typeof getCourse>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(id: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCourse>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetCourseQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCourse>>> = ({ signal }) => getCourse(id, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCourse>>, TError, TData>
}

export type GetCourseQueryResult = NonNullable<Awaited<ReturnType<typeof getCourse>>>
export type GetCourseQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary Get Course
 */

export function useGetCourse<TData = Awaited<ReturnType<typeof getCourse>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 id: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCourse>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCourseQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Get Course Card
 */
export const getCourseCard = (
    id: MaybeRefOrGetter<number>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<Course>(
      {url: `/courses/${id}/card`, method: 'GET', signal
    },
      );
    }




export const getGetCourseCardQueryKey = (id: MaybeRefOrGetter<number>,) => {
    return [
    'courses',id,'card'
    ] as const;
    }


export const getGetCourseCardQueryOptions = <TData = Awaited<ReturnType<typeof getCourseCard>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(id: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCourseCard>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetCourseCardQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCourseCard>>> = ({ signal }) => getCourseCard(id, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCourseCard>>, TError, TData>
}

export type GetCourseCardQueryResult = NonNullable<Awaited<ReturnType<typeof getCourseCard>>>
export type GetCourseCardQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary Get Course Card
 */

export function useGetCourseCard<TData = Awaited<ReturnType<typeof getCourseCard>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 id: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCourseCard>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCourseCardQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






